<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <div v-if="isReadyToDraw" class="myticket-index">
      <div class="index">
        <!-- bookGroupsをfor文でループ表示 -->
        <div class="masterbook_division">
          <ItemIndexBookPassSheet
            :bookGroup="dataList[0].bookGroup"
            :latestStampedAtOfBookGroup="dataList[0].latestStampedAtOfBookGroup"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import bookGroupService from "@/services/bookGroup";

// API
import API from "@/API";

export default {
  name: "MyTicketsTest",

  setup() {
    const store = useStore();

    const dataList = ref([]);
    const isReadyToDraw = ref(false);

    // 次の画面でやると描画の挙動がよくないので、ここで情報を整理
    onMounted(async () => {
      // リセット
      store.commit("ticketing/setbookGroups", null);
      store.commit("ticketing/setbookGroup", []);
      store.commit("ticketing/setBook", []);
      store.commit("ticketing/setSheet", []);
      store.commit("ticketing/setMasterSheet", []);
      store.commit("ticketing/setPass", []);
      store.commit("ticketing/setMasterPass", []);

      // Myチケット取得(未使用)
      await API.getMytickets(false);

      const bookGroups = store.getters["ticketing/bookGroups"];
      const latestStampedAtOfBookGroup = bookGroupService.getLatestStampedAt(
        bookGroups[0].books[0]
      );
      dataList.value.push({
        bookGroup: bookGroups[0],
        latestStampedAtOfBookGroup: latestStampedAtOfBookGroup,
      });
      isReadyToDraw.value = true;
    });
    return {
      dataList,
      isReadyToDraw,
    };
  },
};
</script>
<style scoped lang="scss">
.myticket-index {
  background: #f9f9f9;
  padding: 2vw 0;
}

.index {
  position: relative;
  clear: both;
  width: 96%;
  margin: auto;
}
.masterbook_division {
  border-bottom: 3px solid #f9f9f9;
  background: white;
  border: 1px solid #e0e0e0;
  margin-bottom: 2vw;
  border-radius: 5px;
}
</style>
